import React from 'react';
import { FormattedMessage } from 'react-intl';


const BOOLEAN_OPTIONS = [ 
    {
        value: true,
        label: (
            <FormattedMessage 
                id="base-ui.boolean-options.yes"
                defaultMessage="Yes"
            />
        ),
    }, 
    {
        value: false,
        label: (
            <FormattedMessage 
                id="base-ui.boolean-options.no"
                defaultMessage="No"
            />
        ),
    }, 
];

export default Object.freeze(BOOLEAN_OPTIONS);